import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-playback",
  "use": "icon-playback-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-playback\">\r\n  <path id=\"icon-playback_直播回放\" class=\"cls-1\" d=\"M118,105a6,6,0,1,0,6,6A6,6,0,0,0,118,105Zm0,9a3,3,0,0,1-3-3h.9a2.123,2.123,0,1,0,.78-1.623l-.643-.643A3,3,0,1,1,118,114Zm-1.049-2.924A7.235,7.235,0,0,1,117,110.2a.423.423,0,0,1,.571-.372,5.739,5.739,0,0,1,1.3.783.5.5,0,0,1,0,.763,5.7,5.7,0,0,1-1.319.79.425.425,0,0,1-.571-.393A6.7,6.7,0,0,1,116.951,111.077Z\" transform=\"translate(-112 -105)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol